module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/trapani.1df2a2bcf2472ace027ab5b9c2181012.jpg";